// test2459
(2459 && 0);
